import React from 'react';
import { Link } from 'react-router';
import { OperationRelated } from '../../services/types/Operation';

interface Props {
  operations: OperationRelated[];
}

const RelatedOperations: React.FC<Props> = ({ operations }) => {
  if (!operations) {
    return null;
  }

  return (
    <>
      {operations.map((r, index) => (
        <>
          {index > 0 && <span className="divider">,&nbsp;</span>}
          <Link to={`/operations/${r.id}`}>{r.number}</Link>
        </>
      ))}
    </>
  );
};

export default React.memo(RelatedOperations);
